// Module
var code = "<http-toggle on=Visible off=Hidden default-on=doc.isVisible></http-toggle>";
// Exports
module.exports = code;